import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { AmplitudeIcon, AmplitudeSearchResultIcon } from './icon';

export const amplitudeConfig: ThirdPartyConfig = {
	displayName: 'Amplitude',
	id: 'amplitude',
	resourceType: ProductResourceTypes3P.Amplitude,
	icon: get3PLogo(AmplitudeIcon, 'Amplitude', 'medium'),
	searchResultIcon: get3PLogo(AmplitudeSearchResultIcon, 'Amplitude', 'large'),
	integrationAri: 'ari:cloud:platform::integration/amplitude',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Dashboard,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Dashboard],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
